// extracted by mini-css-extract-plugin
export var footerPartners = "partners-module--footerPartners--2ydEt";
export var footerPartners__content = "partners-module--footerPartners__content--1qfpn";